import { Link } from "react-router-dom";
import { testimonialList } from "@/mocks/site";

export default function VoiceSection() {
  return (
    <section id="voice" className="scroll-mt-32">
      <div className="mb-8">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
          <span className="flex h-3 w-3 items-center justify-center">
            <i className="ri-chat-quote-line text-[11px]"></i>
          </span>
          用户口碑
        </span>
        <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          读者是怎么用的
        </h2>
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
          有人把它当通勤读物，有人拿它对照选题。以下反馈来自读者留言，保留了原文语气。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        {testimonialList.map((item) => (
          <figure
            key={item.name}
            className="flex h-full flex-col rounded-card border border-background-200/80 bg-background-50 p-6"
          >
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
              <i className="ri-double-quotes-l text-base"></i>
            </span>
            <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
              {item.content}
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/70 pt-4">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-500 text-sm font-bold text-background-50">
                {item.name.slice(0, 1)}
              </span>
              <span className="flex flex-col">
                <span className="text-sm font-medium text-foreground-900">{item.name}</span>
                <span className="text-xs text-foreground-500">{item.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>

      <div className="mt-8 flex flex-col items-start gap-4 rounded-card border border-background-200/80 bg-primary-50 p-6 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h3 className="font-heading text-base font-bold text-foreground-950">
            有话想对编辑团队说？
          </h3>
          <p className="mt-1.5 text-sm text-foreground-600">
            无论是内容纠错、选题建议还是合作咨询，都可以通过留言表单联系我们。
          </p>
        </div>
        <Link
          to="/contact"
          className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-mail-send-line text-base"></i>
          </span>
          去留言
        </Link>
      </div>
    </section>
  );
}